/**
 * Renders a euro amount for the checkout cards: "€449", "€5,388", "€99.67".
 *
 * Billing-cycle totals reach four digits, so they need a thousands separator,
 * and the API derives installment prices by division (`unit_amount / 3 / 100`)
 * without rounding — cap the fraction so float dust never reaches the card.
 */
export const formatEuroAmount = (amount: number): string =>
	`€${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(amount)}`;
